import { render, staticRenderFns } from "./ehc-dialog.vue?vue&type=template&id=e22a9e2a"
import script from "./ehc-dialog.vue?vue&type=script&lang=js"
export * from "./ehc-dialog.vue?vue&type=script&lang=js"
import style0 from "./ehc-dialog.vue?vue&type=style&index=0&id=e22a9e2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports